import React from "react";
import { FormBlockType } from "modules/forms/hooks/usefetchForm";

export type StaticBlockType = Omit<FormBlockType, "data"> & {
    data: {
        content: string;
    },
}

export default function StaticBlock(block: StaticBlockType) {
    const { data } = block;

    return (
        <div
            className="text-textColor"
            dangerouslySetInnerHTML={{ __html: data.content }}
        />
    );
}
